import { generateDeleteActionCreator, generateReadOneActionCreator, generateUpdateActionCreator } from '../crudActionCreators';
import ACTION_NAMES from 'actions/ACTION_NAMES';
import routes from 'actions/routes';

export default {
    readProduct: generateReadOneActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT),
    updateProduct: generateUpdateActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT),
    deleteProduct: generateDeleteActionCreator(routes.API_PRODUCT, ACTION_NAMES.PRODUCT)
}
